import { UserService } from './../../base-services/user.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ComponentFactoryResolver, Optional, Inject, Input, TemplateRef } from '@angular/core';
import { BaseEntity } from '../../base-models/base-entity';
import { BaseDataService } from '../../base-services/base-data.service';
import { BaseDefaultListComponent } from './base-default-list.component';
import { ModalContainerService } from '../../base-classes/containers/services/modal-container.service';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../base-services/modal.service';
import { ModelDataService } from '../../base-services/model-data.service';
import { Subject } from 'rxjs';
import { NotificationService } from '../../base-services/notification-service';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-fw-default-list-modal',
  templateUrl: './default-list-tabs.component.html',
  //styleUrls: ['./default-list-modal.component.scss']
  providers: [
    //ModalContainerService
  ]
})
export class DefaultListModalComponent<T extends BaseEntity> extends BaseDefaultListComponent<T> implements OnInit {

  // constructor(
  //   protected activatedRoute: ActivatedRoute,
  //   protected baseDataService: BaseDataService,
  //   protected modalContainerService: ModalContainerService<T>,
  //   protected userService: UserService,
  //   protected notificationsService: NotificationsService,
  //   protected translateService: TranslateService,
  //   protected modalService: ModalService,
  //   protected componentFactoryResolver: ComponentFactoryResolver,
  //   @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService
  // ) {
  //   super(activatedRoute, baseDataService, modalContainerService, userService, notificationsService, translateService, modalService, componentFactoryResolver, modelDataService);
  // }

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected modalContainerService: ModalContainerService<T>,
    protected userService: UserService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService
  ) {
    super(activatedRoute, baseDataService, modalContainerService, userService, toastrService, translateService, modalService, componentFactoryResolver, modelDataService);
  }

  @Input() extraButtonsTemplate: TemplateRef<any>;
  
  ngOnInit() {
    super.ngOnInit();
  }

  private printEventSource = new Subject<void>();
  printEvent$ = this.printEventSource.asObservable();

  CustomPrint() {
    if(this.modelData.MainList.CustomPrint)
      this.printEventSource.next();
    else
      this.Print(); 
  }

  Print(parameters?: any){
    super.Print(parameters);
  }

}
